module.exports = __webpack_public_path__ + "static/media/ClientPanel.70516cd9.jpg";